import { Tooltip, Typography } from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help'
import React from 'react'
import styled from 'styled-components'

import LabelStatusIcon from '../../LabelStatusIcon'

interface LabelStatusLegendProps {
  className?: string
}

const ProductLabelStatusLegend: React.FC<LabelStatusLegendProps> = ({ className }) => (
  <div className={className}>
    <Typography variant="caption">Label on file:</Typography>
    <LabelStatusIcon isLabelPresent={true} />
    <Tooltip
      arrow
      enterTouchDelay={100}
      title="You have a custom label on file with us for this product."
    >
      <HelpIcon />
    </Tooltip>
    <Typography variant="caption">No label on file:</Typography>
    <LabelStatusIcon isLabelPresent={false} />
    <Tooltip
      arrow
      enterTouchDelay={100}
      title="You do not have a custom label on file with us for this product.
        You will be prompted to submit custom label information at checkout."
    >
      <HelpIcon />
    </Tooltip>
  </div>
)

const StyledProductLabelStatusLegend = styled(ProductLabelStatusLegend)(({ theme }) => ({
  backgroundColor: theme.colors.grayscale.white,
  border: '1px solid',
  borderRadius: '8px',
  marginBottom: '15px',
  padding: '10px',
  display: 'grid',
  gridTemplateColumns: 'auto auto auto',
  gridAutoRows: '1fr',
  alignItems: 'center',
  gap: '5px 8px',
}))

export default StyledProductLabelStatusLegend
